const ONE_DAY_SALE_LOCATION = "ONE_DAY_SALE_LOCATION";
const ONE_DAY_SALE_DATE = "ONE_DAY_SALE_DATE";


export const saveOneDaySaleLocation = (data: string) => {
    localStorage.setItem(ONE_DAY_SALE_LOCATION, data);
};

export const getOneDaySaleLocation = () => {
    return localStorage.getItem(ONE_DAY_SALE_LOCATION);
};


export const removeOneDaySaleLocation = () => {
    localStorage.removeItem(ONE_DAY_SALE_LOCATION);
};

export const saveOneDaySaleDate = (data) => {
    localStorage.setItem(ONE_DAY_SALE_DATE, JSON.stringify(data));
    
};

export const getOneDaySaleDate = () => {
    return  JSON.parse(localStorage.getItem(ONE_DAY_SALE_DATE));
};

export const removeOneDaySaleDate = () => {
    localStorage.removeItem(ONE_DAY_SALE_DATE);
};
